// Shared date/time display formatting for booking cards (es-ES locale)

// Format a date-only or datetime string as a short date (e.g. "8 oct 2025").
// Always extracts the UTC YYYY-MM-DD portion and parses as a local date so that
// dates stored as UTC midnight (e.g. "2026-05-27T00:00:00.000Z") are never
// shifted to the previous day in negative-offset timezones (UTC-5/6).
export function formatDate(dateString) {
    if (!dateString) return 'Sin fecha';
    try {
        const str = typeof dateString === 'string' ? dateString : new Date(dateString).toISOString();
        const [year, month, day] = str.slice(0, 10).split('-');
        const date = new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
        if (isNaN(date.getTime())) return 'Fecha inválida';
        return date.toLocaleDateString('es-ES', { month: 'short', day: 'numeric', year: 'numeric' });
    } catch {
        return 'Fecha inválida';
    }
}

// Format a datetime string as a short date with time (e.g. "8 oct 2025, 14:30").
export function formatDateTime(dateString) {
    if (!dateString) return 'Sin fecha';
    try {
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return 'Fecha inválida';
        return date.toLocaleString('es-ES', {
            month: 'short',
            day: 'numeric',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
        });
    } catch {
        return 'Fecha inválida';
    }
}

// Format a datetime string as a time-only value (e.g. "14:30").
export function formatTime(dateString) {
    if (!dateString) return 'Sin hora';
    try {
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return 'Hora inválida';
        return date.toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit' });
    } catch {
        return 'Hora inválida';
    }
}
